/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(self["webpackChunkonskee_shopify_theme"] = self["webpackChunkonskee_shopify_theme"] || []).push([["src_js_main_share_Share_ts"],{

/***/ 3580:
/*!************************************!*\
  !*** ./src/js/main/share/Share.ts ***!
  \************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n\ncustomElements.define(\"share-button\", class ShareButton extends HTMLButtonElement {\n  constructor() {\n    super();\n    this.urlToShare = void 0;\n    this.onclick = () => {\n      if (navigator.share) {\n        navigator.share({\n          url: this.urlToShare,\n          title: document.title\n        });\n      } else {\n        navigator.clipboard.writeText(this.urlToShare).then(() => {\n          // TODO: Show confirmation UI\n        });\n      }\n    };\n    this.urlToShare = this.dataset.url ?? document.location.href;\n  }\n}, {\n  extends: \"button\"\n});\n\n//# sourceURL=webpack://onskee-shopify-theme/./src/js/main/share/Share.ts?");

/***/ })

}])